module.exports = __webpack_public_path__ + "static/SUA16-59554004f1484eabab3fb445ac5c3147.jpg";